import { render, staticRenderFns } from "./PbxzszMm.vue?vue&type=template&id=3b20eafb&scoped=true&"
import script from "./PbxzszMm.vue?vue&type=script&lang=js&"
export * from "./PbxzszMm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20eafb",
  null
  
)

export default component.exports